import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { PropsWithChildren, useState } from "react";

type Props = PropsWithChildren<{
  title: string;
}>;

export function Collapsable({ title, children }: Props) {
  const [open, setOpen] = useState(true);
  return (
    <Box
      bg="transparent"
      border="4px solid white"
      borderRadius={4}
      boxShadow="0px 2px 4px 0px rgba(25, 25, 25, 0.04)"
      p={4}
    >
      <Flex cursor="pointer" onClick={() => setOpen(!open)}>
        <Image
          h={4}
          mr={2}
          mt={1}
          src="/svg/chevron.svg"
          transform={open ? "rotate(0)" : "rotate(180deg)"}
          transition="transform 0.2s"
          w={4}
        />
        <Text fontWeight="500">{title}</Text>
      </Flex>
      {open && <Box>{children}</Box>}
    </Box>
  );
}
